import i18next from 'i18next';

i18next.addResources('es', 'noResults', {
  resultsNoFound: 'No encontramos resultados',
  mainText:
    'Pruebe ajustando su búsqueda y asegúrese de que todas las palabras estén escritas correctamente.',
  popular: 'También podría interesarte'
});

i18next.addResources('en', 'noResults', {
  resultsNoFound: 'No results found',
  mainText:
    'Try adjusting your search and make sure all words are spelled correctly.',
  popular: 'You might also be interested in'
});

i18next.addResources('pt', 'noResults', {
  resultsNoFound: 'Nenhum resultado encontrado',
  mainText:
    'Tente ajustar sua busca e certifique-se de que todas as palavras estejam escritas corretamente.',
  popular: 'Você também pode se interessar'
});
